import Highcharts from "highcharts";
import React from "react";

function useChartEventHandler(
  chartRef: React.RefObject<Highcharts.Chart>,
  event: string,
  callback: Highcharts.EventCallbackFunction<Highcharts.Chart>,
) {
  React.useLayoutEffect(() => {
    const chart = chartRef.current;
    if (!chart) {
      throw new Error("chart not found");
    }

    Highcharts.addEvent(chart, event, callback);
    return () => Highcharts.removeEvent(chart, event, callback);
  }, [chartRef, event, callback]);
}

export default useChartEventHandler;
